const isDev = process.env.NODE_ENV !== 'production';

function subscribe(registration, callback) {
  navigator.serviceWorker.ready.then((sw) => {
    Notification.requestPermission((permission) => {
      if (permission !== 'denied') {
        const options = {
          userVisibleOnly: true,
          applicationServerKey: process.env.VUE_APP_APPLICATION_SERVER_KEY,
        };
        sw.pushManager.subscribe(options).then((s) => {
          const data = {
            isAccept: true,
            endpoint: s.endpoint,
            p256dh: btoa(
              String.fromCharCode.apply(
                null,
                new Uint8Array(s.getKey('p256dh')),
              ),
            )
              .replace(/\+/g, '-')
              .replace(/\//g, '_'),
            auth: btoa(
              String.fromCharCode.apply(null, new Uint8Array(s.getKey('auth'))),
            )
              .replace(/\+/g, '-')
              .replace(/\//g, '_'),
          };
          callback(data);
        });
      } else {
        callback({ isAccept: false });
      }
    });
  });
}

const startRegistration = (callback) => {
  // serviceWorker registration
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then((r) => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          subscribe(registration, callback);
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }
};

const checkSubscriptionStatus = (callback) => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    // PushManager or serviceWorker is support check
    navigator.serviceWorker.getRegistration().then((data) => {
      // registration status check
      if (data !== undefined && data.pushManager !== undefined) {
        data.pushManager.getSubscription().then((subscription) => {
          const isSubscribed = !(subscription === null);
          callback({ isSubscribed });
        });
      } else {
        callback({ isSubscribed: false });
      }
    });
  } else {
    callback({ isSubscribed: undefined });
  }
};

const unsubscribeUser = (callback) => {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker
      .getRegistration()
      .then((data) => {
        if (data) {
          data.unregister();
        }
      })
      .catch((error) => {
        console.log('Error unsubscribing', error);
        callback({ isUnsubscribe: false }); // unsubscribed failed
      })
      .then(() => {
        callback({ isUnsubscribe: true }); // unsibscribed failed
      });
  }
};

export default {
  startRegistration,
  checkSubscriptionStatus,
  unsubscribeUser,
};
